import fetcher from 'api/fetcher';
import { AxiosError } from 'axios';
import { MagritteNotificationName } from 'utils/constants/notification';

import { getPromoCodeStatus } from 'components/Admin/PromoCodes/utils/getPromoCodeStatus';

import { addMagritteNotification } from 'store/models/notification';
import { addPromoCode, PromoCodeBonus, PromoCodeBound, PromoCodeDTO } from 'store/models/promoCodes';
import { AppThunkAction } from 'store/utils';

export interface CreatePromoCodeRequest {
    promoCode: string;
    description: string;
    bonus: PromoCodeBonus;
    startDate: string | null;
    endDate: string | null;
    activationsLimit: number | null;
    bound?: PromoCodeBound | null;
}

export const createPromoCode =
    (
        data: CreatePromoCodeRequest,
        setIsLoading: (loading: boolean) => void,
        onSuccess: () => void
    ): AppThunkAction<Promise<void> | null> =>
    (dispatch) => {
        setIsLoading(true);
        return fetcher
            .post('/api/v1/backoffice/promo_codes', data)
            .then(async () => {
                const addedPromoCode = await fetcher.get<unknown, PromoCodeDTO>(
                    `/api/v1/backoffice/promo_codes/code/${data.promoCode}`
                );
                dispatch([
                    addPromoCode({
                        ...addedPromoCode,
                        status: getPromoCodeStatus(addedPromoCode),
                    }),
                    addMagritteNotification(MagritteNotificationName.AdminCreatePromoCodeSuccess),
                ]);
                onSuccess();
            })
            .catch((err: AxiosError<Error>) => {
                if (err?.response?.status === 409) {
                    dispatch(addMagritteNotification(MagritteNotificationName.AdminCreatePromoCodeDuplicationError));
                } else {
                    dispatch(addMagritteNotification(MagritteNotificationName.AdminCreatePromoCodeError));
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
